import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          专题合集
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-4 md:p-5 text-center hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-3 group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${item.icon} text-foreground-600 group-hover:text-primary-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-medium text-accent-600 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}